export const ACTIVE_DOMAIN_TYPE_SELECTED = 'ACTIVE_DOMAIN_TYPE_SELECTED';
export const CHANGE_EMAIL_VALUE = 'CHANGE_EMAIL_VALUE';
export const CHANGE_PASSWORD_VALUE = 'CHANGE_PASSWORD_VALUE';
export const CHECKOUT_CONFIG_GENERATED = 'CHECKOUT_CONFIG_GENERATED';
export const CHECKOUT_CONFIG_REQUESTED = 'CHECKOUT_CONFIG_REQUESTED';
export const CLEAR_TEMPORARY_STATE = 'CLEAR_TEMPORARY_STATE';
export const CONTINUING_WITH_DOMAIN = 'CONTINUING_WITH_DOMAIN';
export const DOMAIN_FIELD_VALUE_CHANGED = 'DOMAIN_FIELD_VALUE_CHANGED';
export const DOMAIN_VALIDATION_REQUESTED = 'DOMAIN_VALIDATION_REQUESTED';
export const DOMAIN_VALIDATION_VALIDATED = 'DOMAIN_VALIDATION_VALIDATED';
export const DOMAIN_VALUE_TRANSFORMED = 'DOMAIN_VALUE_TRANSFORMED';
export const FORWARDING_TO_CHECKOUT = 'FORWARDING_TO_CHECKOUT';
export const GENERAL_REQUEST_FAILED = 'GENERAL_REQUEST_FAILED';
export const INVALID_USER_ID_TOKEN = 'INVALID_USER_ID_TOKEN';
export const LOGIN_LINK_FAILED = 'LOGIN_LINK_FAILED';
export const UNSET_GLOBAL_ERROR = 'UNSET_GLOBAL_ERROR';
export const LOGIN_LINK_PASSED = 'LOGIN_LINK_PASSED';
export const LOGIN_LINK_REQUESTED = 'LOGIN_LINK_REQUESTED';
export const PRODUCT_TLD_EXTRACTED = 'PRODUCT_TLD_EXTRACTED';
export const RESET_ALL_HINTS = 'REMOVE_ALL_HINTS';
export const RETRIEVED_PRICES = 'RETRIEVED_PRICES';
export const SET_PRODUCT = 'SET_PRODUCT';
export const SET_INDUSTRY = 'SET_INDUSTRY';
export const SET_MOBILE_SETTINGS = 'SET_MOBILE_SETTINGS';
export const SET_OTHER = 'SET_OTHER';
export const SET_PACKAGE = 'SET_PACKAGE';
export const SET_PACKAGES = 'SET_PACKAGES';
export const SET_RANKING_COACH_AVAILABLE = 'SET_RANKING_COACH_AVAILABLE';
export const SET_SIGNUP_WITH_BACKGROUND = 'SET_SIGNUP_WITH_BACKGROUND';
export const SET_SIGNUP_WITH_GIVE_ME_FIVE = 'SET_SIGNUP_WITH_GIVE_ME_FIVE';
export const SET_SIGNUP_WITH_GIVE_ME_FIVE_DESC = 'SET_SIGNUP_WITH_GIVE_ME_FIVE_DESC';
export const SET_SIGNUP_WITH_DELAYED_LOGIN = 'SET_SIGNUP_WITH_DELAYED_LOGIN';
export const SET_SIGNUP_WITH_THREE_VERSUS_FIVE = 'SET_SIGNUP_WITH_THREE_VERSUS_FIVE';
export const SET_SIGNUP_WITH_PRODUCT_NAMING = 'SET_SIGNUP_WITH_PRODUCT_NAMING';
export const SET_SUBTYPE = 'SET_SUBTYPE';
export const SET_AFFILIATE_ID = 'SET_AFFILIATE_ID';
export const SET_TRIAL_TYPE = 'SET_TRIAL_TYPE';
export const SHOW_FREE_DOMAIN_HINT = 'SHOW_FREE_DOMAIN_HINT';
export const SHOW_PASSWORD = 'SHOW_PASSWORD';
export const SHOW_PRODUCT_DOMAIN_HINT = 'SHOW_PRODUCT_DOMAIN_HINT';
export const SHOW_TRANSFER_DOMAIN_HINT = 'SHOW_TRANSFER_DOMAIN_HINT';
export const SIGNUP_SUBMIT_REQUESTED = 'SIGNUP_SUBMIT_REQUESTED';
export const SIGNUP_SUBMIT_VALIDATED = 'SIGNUP_SUBMIT_VALIDATED';
export const SKIP_INDUSTRY_VIEW = 'SKIP_INDUSTRY_VIEW';
export const SKIP_PRICING_VIEW = 'SKIP_PRICING_VIEW';
export const SKIP_TEMPLATE_VIEW = 'SKIP_TEMPLATE_VIEW';
export const SKIP_CATEGORY_VIEW = 'SKIP_CATEGORY_VIEW';
export const INCREASE_AMOUNT_TEMPLATES = 'INCREASE_AMOUNT_TEMPLATES';
export const RESET_AMOUNT_TEMPLATES = 'RESET_AMOUNT_TEMPLATES';
export const TLD_VALUE_CHANGED = 'TLD_VALUE_CHANGED';
export const USERNAME_VALIDATION_REQUESTED = 'USERNAME_VALIDATION_REQUESTED';
export const USERNAME_VALUE_CHANGED = 'USERNAME_VALUE_CHANGED';
export const USERNAME_VALUE_TRANSFORMED = 'USERNAME_VALUE_TRANSFORMED';
export const USERNAME_VALUE_VALIDATED = 'USERNAME_VALUE_VALIDATED';
export const USER_HAD_PERSISTED_STATE = 'USER_HAD_PERSISTED_STATE';
export const VALIDATE_EMAIL = 'VALIDATE_EMAIL';
export const VALIDATE_EMAIL_REQUESTED = 'VALIDATE_EMAIL_REQUESTED';
export const VALIDATE_EMAIL_VALIDATED = 'VALIDATE_EMAIL_VALIDATED';
export const VALIDATE_PASSWORD_VALIDATED = 'VALIDATE_PASSWORD_VALIDATED';
export const WEBSITE_CREATION_FAIL = 'WEBSITE_CREATION_FAIL';
export const WEBSITE_CREATION_REQUESTED = 'WEBSITE_CREATION_REQUESTED';
export const WEBSITE_CREATION_SUCCESS = 'WEBSITE_CREATION_SUCCESS';
export const WEBSITE_ID_FAILED = 'WEBSITE_ID_FAILED';
export const WEBSITE_ID_PASSED = 'WEBSITE_ID_PASSED';
export const WEBSITE_READY = 'WEBSITE_READY';
export const ROUTER_PUSH_ACTION = 'ROUTER_PUSH_ACTION';
export const SET_PRE_SELECTED_PRODUCT = 'SET_PRE_SELECTED_PRODUCT';
export const SET_USER_ID_TOKEN = 'SET_USER_ID_TOKEN';
export const EXCLUDE_FROM_FORCE_INTO_DOLPHIN_TEST = 'EXCLUDE_FROM_FORCE_INTO_DOLPHIN_TEST';
export const FORCE_INTO_DOLPHIN = 'FORCE_INTO_DOLPHIN';
export const INCLUDE_IN_CLAIMS_TEST = 'INCLUDE_IN_CLAIMS_TEST';
export const SET_EASY_MARKETING_TRACKING_ID = 'SET_EASY_MARKETING_TRACKING_ID';
export const SHOW_THREE_MONTH_DISCOUNT_BADGE = 'SHOW_THREE_MONTH_DISCOUNT_BADGE';
export const SET_LOADING_CTA = 'SET_LOADING_CTA'; // TODO clean-up GRW-1410 GRW-1416
export const SET_LOADING_PAGE = 'SET_LOADING_PAGE'; // TODO clean-up GRW-1410 GRW-1416
export const TOS_ACCEPTANCE_FAILED = 'TOS_ACCEPTANCE_FAILED'; // TODO clean-up GRW-1410 GRW-1416
export const SET_TOS_ACCEPTANCE_STATUS = 'SET_TOS_ACCEPTANCE_STATUS'; // TODO clean-up GRW-1410 GRW-1416
export const SET_USER_HAS_BUSINESS = 'SET_USER_HAS_BUSINESS'; // TODO clean-up GRW-1410 GRW-1416
